import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import SchoolLayout from "layouts/School.js";
import CollectiveLayout from "layouts/Collective.js";
import AuthLayout from "layouts/Auth.js";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://8f7194a838df6ce38d6654ed257d87e2@o4507571489210368.ingest.de.sentry.io/4508992589725776",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const App = () => {
  let { uid, user } = useSelector((state) => state.auth);
  console.log("env", process.env.REACT_APP_FIREBASE_API_KEY);
  return (
    <>
      <BrowserRouter>
        {uid ? (
          <>
            {user.type == "collective" ? (
              <Switch>
                <Route
                  path="/collective"
                  render={(props) => <CollectiveLayout {...props} />}
                />
                <Redirect from="/" to="/collective/index" />
              </Switch>
            ) : (
              <Switch>
                <Route
                  path="/school"
                  render={(props) => <SchoolLayout {...props} />}
                />
                <Redirect from="/" to="/school/index" />
              </Switch>
            )}
          </>
        ) : (
          <Switch>
            <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
            <Redirect from="/" to="/auth/login" />
          </Switch>
        )}
      </BrowserRouter>
    </>
  );
};

export default process.env.NODE_ENV === "production"
  ? Sentry.withErrorBoundary(App, {
      fallback: (
        <div className="d-flex flex-column align-items-center justify-content-center text-danger py-5">
          <div className="fw-bold text-center fs-1">
            Something went wrong. Please try again later. 🚨
          </div>
        </div>
      ),
    })
  : App;
